import { render, staticRenderFns } from "./dealerList.vue?vue&type=template&id=0bf6f70c"
import script from "./dealerList.vue?vue&type=script&lang=js"
export * from "./dealerList.vue?vue&type=script&lang=js"
import style0 from "./dealerList.vue?vue&type=style&index=0&id=0bf6f70c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports